import { useState } from 'react';
import Link from '@components/Link';
import { request } from '@apis/utils';
import { validateEmail } from '@helpers/forms';
import Styles from './PasswordReset.module.scss';
import LoginStyles from '../login/Login.module.scss';
import Hero from '@components/PageComponents/Hero/Hero';
import BaseLayout from '@components/Layout/BaseLayout';
import Button from '@hiredigital/ui/Button';
import TextInput from '@hiredigital/ui/Input/SimpleTextInput';
import Loader from '@hiredigital/ui/Loader';
import Logo from '@hiredigital/ui/Logo';

const PasswordResetPage = (props) => {
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState('');

  const handleChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setEmailValid(value.length >= 1);
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (name === 'email') {
      setEmailValid(validateEmail(value));
    }
  };

  const handleKeyPress = (event) => {
    if (event.which === 13) {
      this.handleSubmit(event);
    }
  };

  const handleSubmit = (event) => {
    if (email) {
      setLoading(true);
      setResponse('');

      const url = `accounts/password/reset/`;
      const payload = {
        email: email,
      };

      request.post(url, payload).then(
        (response) => {
          setLoading(false);
          setResponse(response.data.detail);
        },
        (error) => {
          setLoading(false);
          console.log('error', error);
        }
      );
    } else {
      setEmailValid(false);
    }
  };

  const pageHead = {
    title: `Password Reset | Hire Digital`,
    meta: [{ name: 'robots', content: 'noindex' }],
  };

  return (
    <BaseLayout pageHead={pageHead}>
      <div className={Styles.container}>
        <Hero parent={Hero.Page.LOGIN} square={true}>
          <div className={LoginStyles.contentWrapper}>
            <div className={LoginStyles.formContainer} data-test-id='login-form'>
              <Link className={LoginStyles.logoContainer} to='/'>
                <Logo className={LoginStyles.logo} type={Logo.Type.WHITE} site={'3'} />
              </Link>
              <div className={LoginStyles.card}>
                <div>
                  <h1 className={LoginStyles.headline}>{`Password Reset`}</h1>
                  <p className={LoginStyles.description}>
                    {`Enter your e-mail address to reset your password and we'll send you an email to confirm. You may need to check your spam folder or unblock team@hiredigital.com`}
                  </p>

                  {response && <p className={LoginStyles.confirmMessage}>{response}</p>}
                </div>
                <div className={LoginStyles.inputContainer}>
                  <TextInput
                    name='email'
                    label='Email Address'
                    error={!emailValid && `Enter your email address.`}
                    value={email}
                    onBlur={handleBlur}
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                  />
                </div>
                <div className={Styles.resetActionContainer}>
                  <Button
                    className=''
                    name='submit'
                    type={Button.Type.BLUE}
                    size={Button.Size.FULLWIDTH}
                    onClick={handleSubmit}
                    isLoading={loading}>
                    {`Reset Password`}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Hero>
      </div>
    </BaseLayout>
  );
};

export default PasswordResetPage;
